import React, { useState, useEffect } from "react";
import "./Home.css";
import { db } from "../firebase";
import { collection, getDocs, orderBy, query, limit } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Location from "./Location";
import { trackPageView, trackProductView } from "../utils/analytics";

export default function Home() {
  const navigate = useNavigate();
  const [latestProducts, setLatestProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Track page view
    trackPageView('home', 'Kid\'s Vibes - Home');

    const loadProducts = async () => {
      try {
        // Load different number of products based on screen size
        const productLimit = isMobile ? 6 : 9;
        const q = query(
          collection(db, "products"), 
          orderBy("createdAt", "desc"), 
          limit(productLimit)
        );
        const querySnapshot = await getDocs(q);
        const productsData = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          productsData.push({ 
            id: doc.id, 
            ...data,
            // Ensure availability field exists, default to "In stock" if missing
            availability: data.availability || "In stock"
          });
        });
        setLatestProducts(productsData);
      } catch (error) {
        console.error("Error fetching latest products:", error);
        setLatestProducts([]);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [isMobile]); // Reload when screen size changes
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <img 
          src="/images/hero section for websie .png" 
          alt="Hero Background" 
          className="hero-background-img"
        />
        <div className="hero-shop-btn">
          <button 
            className="shop-now-btn"
            onClick={() => {
              trackPageView('shop_now_click', 'Shop Now from Hero');
              navigate('/products');
            }}
          >
            Shop now
          </button>
        </div>
      </section>

      {/* Latest Updates Header - in white section */}
      <div className="latest-header-white">
        <h3 className="latest-title">Latest Updates</h3>
        <button 
          className="see-all-btn"
          onClick={() => {
            trackPageView('all_products', 'All Products');
            navigate('/products');
          }}
        >
          View all
        </button>
      </div>

      {/* Latest Updates Products - in grey section */}
      <div className="latest-section">
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
            <p>Loading latest products...</p>
          </div>
        ) : (
          <div className="product-grid-mobile">
            {latestProducts.map((product) => (
              <div 
                className="product-card-mobile" 
                key={product.id}
                onClick={() => trackProductView(product.id, product.name)}
                style={{ cursor: 'pointer' }}
              >
                <div className="product-image-container">
                  <img src={product.image} alt={product.name} className="product-img-mobile" />
                </div>
                <div className="product-details">
                  <h4 className="product-name-mobile">{product.name}</h4>
                  <p className="product-price-mobile">{product.price}</p>
                  <div className="availability-container">
                    <span className="availability-label">Status</span>
                    <span className={`availability-status ${(product.availability === 'In stock' || !product.availability) ? 'in-stock' : 'sold-out'}`}>
                      {(product.availability === 'In stock' || !product.availability) ? 'In stock' : 'Sold out'}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Location Section */}
      <div id="location">
        <Location />
      </div>
    </div>
  );
}